/**
 * Block is used on
 *
 * @returns {{layout: string, slides: [], activeSlide: null, pagedSlides: [], previousPage(): (undefined), getPreviousSlide(): void, getNextSlide(): void, nextPage(): void, update(): void, chunk(*, *): [], currentPage: number, visibleSlides: []}}
 */
export default () => ({
    slides: [],
    visibleSlides: [],
    activeSlide: null,
    layout: 'grid',

    currentPage: 0,
    pagedSlides: [],

    update() {
        this.pages = Math.ceil(this.slides.length / 4);

        this.pagedSlides = this.chunk(this.slides, 4);
        this.visibleSlides = this.pagedSlides[0];
    },

    getNextSlide() {
        let index = this.slides.indexOf(this.activeSlide);
        if(index >= 0 && index <  this.slides.length - 1) {
            this.activeSlide = this.slides[index + 1]
            this.activeSlide.visible = true;
        } else {
            this.activeSlide = this.slides[0]
            this.activeSlide.visible = true;
        }
    },

    getPreviousSlide() {
        let index = this.slides.indexOf(this.activeSlide);
        if(index >= 1 && index < this.slides.length + 1) {
            this.activeSlide = this.slides[index - 1]
            this.activeSlide.visible = true;
        }
    },

    nextPage() {
        this.currentPage++;
        if (this.pagedSlides[this.currentPage] === undefined) {
            this.currentPage = 0;
            this.visibleSlides = this.pagedSlides[0];
        }
        else
            this.visibleSlides = this.pagedSlides[this.currentPage];
    },

    previousPage() {
        if (this.currentPage === 0)
            return;

        this.currentPage--;
        this.visibleSlides = this.pagedSlides[this.currentPage];
    },

    chunk (arr, len) {
        let chunks = [],
            i = 0,
            n = arr.length;

        while (i < n) {
            chunks.push(arr.slice(i, i += len));
        }

        return chunks;
    }
})